import React, { useEffect, useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HeaderDashboard from '../../components/HeaderDashboard';
import { useNavigate } from 'react-router-dom';
import { Button, Chip, Switch, Collapse, Divider } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Box, Typography } from "@mui/material";
import { useUser } from '../../../contexts/UserContext';
import { MascaraCpf } from '../../../utils/MascaraCpf';
import { MascaraCnpj } from '../../../utils/MascaraCnpj';
import axios from 'axios';
import { TirarMascara } from '../../../utils/TirarMascara';
import { MascaraCep } from '../../../utils/MascaraCep';
import Loading from '../../components/Loading';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { NumericFormat } from 'react-number-format';
import { MascaraValor } from '../../../utils/MascaraValor';
import AlertError from '../../components/AlertError';
import ReceiptIcon from '@mui/icons-material/Receipt';
import HomeIcon from '@mui/icons-material/Home';
import { Breadcrumbs, Link } from "@mui/material";
import AlertSuccess from '../../components/AlertSuccess';
import BusinessIcon from '@mui/icons-material/Business';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const estados = [
    "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA",
    "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN",
    "RS", "RO", "RR", "SC", "SP", "SE", "TO"
];

// Valores do enum taxationType da Spedy (POST /v1/service-invoices)
const tiposTributacao = [
    { valor: "taxationInMunicipality", label: "Tributação no município" },
    { valor: "taxationOutsideMunicipality", label: "Tributação fora do município" },
    { valor: "exemption", label: "Isenção" },
    { valor: "immune", label: "Imune" },
    { valor: "suspendedByCourt", label: "Exigibilidade suspensa por decisão judicial" },
    { valor: "suspendedByAdministrativeProcedure", label: "Exigibilidade suspensa por processo administrativo" },
    { valor: "exportation", label: "Exportação" },
    { valor: "nonIncidence", label: "Não incidência" },
];

// Retenções federais informadas em valor; o ISS retido é calculado pela alíquota
const retencoesFederais = [
    { chave: "ir", label: "IR", campoValor: "irAmount", campoRetido: "irWithheld" },
    { chave: "pis", label: "PIS", campoValor: "pisAmount", campoRetido: "pisWithheld" },
    { chave: "cofins", label: "COFINS", campoValor: "cofinsAmount", campoRetido: "cofinsWithheld" },
    { chave: "csll", label: "CSLL", campoValor: "csllAmount", campoRetido: "csllWithheld" },
    { chave: "inss", label: "INSS", campoValor: "inssAmount", campoRetido: "inssWithheld" },
];

const retencoesIniciais = () => Object.fromEntries(retencoesFederais.map((r) => [r.chave, { ativo: false, valor: "" }]));

// integrationId garante idempotência na Spedy: reenviar o mesmo id atualiza a nota em vez de duplicar
const novoIdIntegracao = () =>
    (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`).slice(0, 36);

const arredondar = (numero) => Math.round((Number.isFinite(numero) ? numero : 0) * 100) / 100;

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

const campoSx = {
    "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff" },
};

const linhaCamposSx = (colunas) => ({
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: colunas },
    gap: 1.5,
});

// Definido fora do componente para não remontar os inputs (e perder o foco) a cada render
const SecaoCard = ({ icone, titulo, descricao, acao, children }) => (
    <Box sx={cardSx}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap", mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: "8px",
                        backgroundColor: "#f3f4f6",
                        color: "#374151",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        "& svg": { fontSize: 20 },
                    }}
                >
                    {icone}
                </Box>
                <Box>
                    <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>{titulo}</Typography>
                    <Typography sx={{ fontSize: 12, color: "#6b7280" }}>{descricao}</Typography>
                </Box>
            </Box>
            {acao}
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>{children}</Box>
    </Box>
);

const LinhaResumo = ({ label, valor, destaque }) => (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 1 }}>
        <Typography sx={{ fontSize: 13, color: "#cbd5e1" }}>{label}</Typography>
        <Typography sx={{ fontSize: destaque ? 20 : 13, fontWeight: destaque ? 700 : 600, color: destaque ? "#ffc845" : "#fff", textAlign: "right" }}>
            {valor}
        </Typography>
    </Box>
);

const hoje = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

const moeda = (numero) => (Number.isFinite(numero) ? numero : 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const EmitirNotaServico = () => {
    const { user, fetchUser } = useUser();
    const navigate = useNavigate();
    const [userActive, setUserActive] = useState(true);
    const [notificacoes, setNotificacoes] = useState([]);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [hasTomador, setHasTomador] = useState(true);
    const [servicos, setServicos] = useState([]);

    const [cpfCnpjTomador, setCpfCnpjTomador] = useState('');
    const [razaoSocialTomador, setRazaoSocialTomador] = useState('');
    const [emailTomador, setEmailTomador] = useState('');
    const [inscricaoMunicipalTomador, setInscricaoMunicipalTomador] = useState('');
    const [cepTomador, setCepTomador] = useState('');
    const [enderecoTomador, setEnderecoTomador] = useState('');
    const [numeroTomador, setNumeroTomador] = useState('');
    const [estadoTomador, setEstadoTomador] = useState('');
    const [cidadeTomador, setCidadeTomador] = useState('');
    const [bairroTomador, setBairroTomador] = useState('');
    const [codigoIbgeTomador, setCodigoIbgeTomador] = useState('');
    const [enviarEmailTomador, setEnviarEmailTomador] = useState(true);
    const [servicoSelecionado, setServicoSelecionado] = useState(null);
    const [descricaoServico, setDescricaoServico] = useState('');
    const [valorServico, setValorServico] = useState('');
    const [aliquota, setAliquota] = useState('0');

    const [mostrarAvancadas, setMostrarAvancadas] = useState(false);
    const [dataCompetencia, setDataCompetencia] = useState(hoje());
    const [deducoes, setDeducoes] = useState('');
    const [informacoesComplementares, setInformacoesComplementares] = useState('');

    const [tipoTributacao, setTipoTributacao] = useState('taxationInMunicipality');
    const [retencoes, setRetencoes] = useState(retencoesIniciais);
    const [reterISS, setReterISS] = useState(false);

    // Renovado só após sucesso: um novo clique após erro/timeout reaproveita o id e não duplica a nota
    const [idIntegracao, setIdIntegracao] = useState(novoIdIntegracao);
    const [emitindo, setEmitindo] = useState(false);

    const [open, setOpen] = useState(false);
    const [mensagem, setMensagem] = useState("");
    const [openSnackbarError, setOpenSnackbarError] = useState(false);
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);


    useEffect(() => {
        if (servicos.length === 0) {
            fetchUser();
        }
        setServicos(user?.servicos || []);
    }, [user]);

    // A Spedy identifica a cidade do tomador pelo código IBGE, que o ViaCEP devolve junto com o endereço
    const buscarCep = async (cep, manterEnderecoPreenchido = false) => {
        const somenteNumeros = TirarMascara(cep);
        if (somenteNumeros.length !== 8) return;

        try {
            const { data } = await axios.get(`https://viacep.com.br/ws/${somenteNumeros}/json/`);
            if (!data || data.erro) {
                setCodigoIbgeTomador('');
                return;
            }

            setCodigoIbgeTomador(data.ibge || '');
            const preencher = (setter, valor) => {
                if (valor) setter((atual) => (manterEnderecoPreenchido && atual ? atual : valor));
            };
            preencher(setEnderecoTomador, data.logradouro);
            preencher(setBairroTomador, data.bairro);
            preencher(setCidadeTomador, data.localidade);
            preencher(setEstadoTomador, data.uf);
        } catch (error) {
            console.error("Erro ao buscar CEP:", error?.response || error);
            setCodigoIbgeTomador('');
        }
    };

    const handleCepTomador = (value) => {
        const cepFormatado = MascaraCep(value);
        setCepTomador(cepFormatado);
        if (TirarMascara(cepFormatado).length === 8) {
            buscarCep(cepFormatado);
        } else {
            setCodigoIbgeTomador('');
        }
    };

    const handleCpfCnpjTomador = async (value) => {
        if (!value) return;

        const somenteNumeros = value.replace(/\D/g, "");

        // CPF
        if (somenteNumeros.length <= 11) {
            setCpfCnpjTomador(MascaraCpf(value));
            return;
        }

        // CNPJ
        const cnpjFormatado = MascaraCnpj(value);
        setCpfCnpjTomador(cnpjFormatado);

        // Só busca quando CNPJ estiver completo
        if (somenteNumeros.length !== 14) return;

        try {
            setOpen(true);
            console.log("Buscando CNPJ:", somenteNumeros);

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/buscarCnpj/${somenteNumeros}`,
                {
                    headers: {
                        "Authorization": localStorage.getItem("token"),
                    },
                }
            );

            const data = response?.data.data;

            if (!data) {
                setMensagem("CNPJ não encontrado.");
                setOpenSnackbarError(true);
                return;
            }

            const endereco = data?.endereco || {};

            setRazaoSocialTomador(data.razao_social ?? "");
            setEmailTomador(data.email ?? "");
            setCepTomador(MascaraCep(endereco.cep ?? ""));
            setEnderecoTomador(endereco.logradouro ?? "");
            setNumeroTomador(endereco.numero ?? "");
            setBairroTomador(endereco.bairro ?? "");
            setCidadeTomador(endereco.municipio ?? "");
            setEstadoTomador(endereco.uf ?? "");
            await buscarCep(endereco.cep ?? "", true);

        } catch (error) {
            console.error("Erro ao buscar CNPJ:", error?.response || error);

            setMensagem(
                "Erro ao buscar CNPJ. Verifique o número ou tente novamente mais tarde."
            );
            setOpenSnackbarError(true);

        } finally {
            setOpen(false);
        }
    };

    const formatarValor = (valor) => {
        return Number(String(valor || "").replace("R$ ", "").replace(/\./g, "").replace(",", ".")) || 0;
    };

    const atualizarRetencao = (chave, campo, valor) => {
        setRetencoes((atuais) => ({ ...atuais, [chave]: { ...atuais[chave], [campo]: valor } }));
    };

    // Valores calculados usados no resumo e no payload da Spedy
    const valorBruto = formatarValor(valorServico);
    const totalDeducoes = formatarValor(deducoes);
    const baseCalculo = arredondar(valorBruto - totalDeducoes);
    const aliquotaIss = parseFloat(String(aliquota || "0").replace(',', '.')) || 0;
    const valorIss = arredondar(baseCalculo * aliquotaIss / 100);
    const valoresRetencoes = Object.fromEntries(
        retencoesFederais.map((r) => [r.chave, retencoes[r.chave].ativo ? formatarValor(retencoes[r.chave].valor) : 0])
    );
    const totalRetido = arredondar(
        Object.values(valoresRetencoes).reduce((soma, valor) => soma + valor, 0) + (reterISS ? valorIss : 0)
    );
    const valorLiquido = arredondar(valorBruto - totalRetido);

    const montarTomador = () => {
        const cidade = {};
        if (codigoIbgeTomador) cidade.code = Number(codigoIbgeTomador);
        if (cidadeTomador) cidade.name = cidadeTomador;
        if (estadoTomador) cidade.state = estadoTomador.toLowerCase();

        return {
            name: razaoSocialTomador,
            federalTaxNumber: TirarMascara(cpfCnpjTomador),
            cityTaxNumber: inscricaoMunicipalTomador || undefined,
            email: emailTomador || undefined,
            address: {
                street: enderecoTomador || undefined,
                number: numeroTomador || undefined,
                district: bairroTomador || undefined,
                postalCode: TirarMascara(cepTomador) || undefined,
                city: Object.keys(cidade).length > 0 ? cidade : undefined,
                country: "BRA",
            },
        };
    };

    // Corpo no formato do POST /v1/service-invoices da Spedy; o backend só completa os dados do prestador e repassa
    const montarNotaSpedy = () => {
        const total = {
            invoiceAmount: arredondar(valorBruto),
            deductionsAmount: totalDeducoes > 0 ? arredondar(totalDeducoes) : undefined,
            issBaseTax: baseCalculo,
            issRate: aliquotaIss,
            issAmount: valorIss,
            issWithheld: reterISS,
            netAmount: valorLiquido,
        };

        retencoesFederais.forEach((r) => {
            if (!retencoes[r.chave].ativo) return;
            total[r.campoRetido] = true;
            total[r.campoValor] = arredondar(valoresRetencoes[r.chave]);
        });

        return {
            integrationId: idIntegracao,
            effectiveDate: `${dataCompetencia}T12:00:00-03:00`,
            description: descricaoServico.trim() || servicoSelecionado.discriminacao,
            additionalInformation: informacoesComplementares.trim() || undefined,
            federalServiceCode: servicoSelecionado.codigo ? String(servicoSelecionado.codigo) : undefined,
            cnaeCode: servicoSelecionado.cnae ? TirarMascara(String(servicoSelecionado.cnae)) : undefined,
            taxationType: tipoTributacao,
            sendEmailToCustomer: hasTomador && enviarEmailTomador && !!emailTomador,
            receiver: hasTomador ? montarTomador() : undefined,
            total,
        };
    };

    const limparFormulario = () => {
        setAliquota('0');
        setServicoSelecionado(null);
        setDescricaoServico('');
        setValorServico('');
        setDataCompetencia(hoje());
        setDeducoes('');
        setInformacoesComplementares('');
        setTipoTributacao('taxationInMunicipality');
        setRetencoes(retencoesIniciais());
        setReterISS(false);
        setCpfCnpjTomador('');
        setRazaoSocialTomador('');
        setEmailTomador('');
        setInscricaoMunicipalTomador('');
        setCepTomador('');
        setEnderecoTomador('');
        setNumeroTomador('');
        setEstadoTomador('');
        setCidadeTomador('');
        setBairroTomador('');
        setCodigoIbgeTomador('');
        setEnviarEmailTomador(true);
        setIdIntegracao(novoIdIntegracao());
    };

    const handleEmitirNota = async () => {
        if (emitindo) return;

        if (!servicoSelecionado) {
            setMensagem('Por favor, selecione o serviço prestado.');
            setOpenSnackbarError(true);
            return;
        }

        if (!valorServico || formatarValor(valorServico) <= 0) {
            setMensagem('Por favor, insira um valor válido para o serviço.');
            setOpenSnackbarError(true);
            return;
        }

        if (totalDeducoes > valorBruto) {
            setMensagem('As deduções não podem ser maiores que o valor do serviço.');
            setOpenSnackbarError(true);
            return;
        }

        if (hasTomador) {
            const documento = TirarMascara(cpfCnpjTomador);
            if (!razaoSocialTomador || (documento.length !== 11 && documento.length !== 14)) {
                setMensagem('Por favor, informe um CPF/CNPJ válido e o nome do tomador.');
                setOpenSnackbarError(true);
                return;
            }
        }

        const retencaoSemValor = retencoesFederais.find((r) => retencoes[r.chave].ativo && valoresRetencoes[r.chave] <= 0);
        if (retencaoSemValor) {
            setMensagem(`Informe o valor retido de ${retencaoSemValor.label} ou desative a retenção.`);
            setOpenSnackbarError(true);
            return;
        }

        if (valorLiquido < 0) {
            setMensagem('O total de retenções não pode ser maior que o valor do serviço.');
            setOpenSnackbarError(true);
            return;
        }

        setEmitindo(true);
        setOpen(true);

        try {
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/emitirNotaServico`, montarNotaSpedy(), {
                headers: {
                    Authorization: localStorage.getItem('token'),
                    'Content-Type': 'application/json'
                }
            });

            if (data.status !== 200) {
                throw new Error(data.message || 'Erro desconhecido ao emitir nota fiscal.');
            }

            // A Spedy processa a NFS-e de forma assíncrona: o retorno indica que a nota entrou na fila, não que foi autorizada
            const statusNota = data.nota?.status;
            if (statusNota === 'authorized') {
                setMensagem('Nota fiscal autorizada com sucesso!');
            } else if (statusNota === 'rejected' || statusNota === 'denied') {
                throw new Error(data.nota?.processingDetail?.message || 'A prefeitura rejeitou a nota fiscal.');
            } else {
                setMensagem('Nota fiscal enviada para a prefeitura. Acompanhe a autorização em Notas fiscais emitidas.');
            }
            setOpenSnackbarSuccess(true);
            limparFormulario();
        } catch (error) {
            console.error("Erro ao emitir nota fiscal:", error?.response || error);
            const detalhe = error?.response?.data?.message || error?.message;
            setMensagem(detalhe ? `Erro ao emitir nota fiscal: ${detalhe}` : 'Erro ao emitir nota fiscal, tente novamente mais tarde.');
            setOpenSnackbarError(true);
        } finally {
            setEmitindo(false);
            setOpen(false);
        }
    };

    const handleChange = (event) => {
        setEstadoTomador(event.target.value);
    };

    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <ReceiptIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Emitir NFS-e
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Emitir Nota Fiscal de Serviço
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Preencha os dados do tomador e do serviço prestado. Confira o resumo antes de emitir.
                        </Typography>
                    </Box>
                    <Button
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate("../Dashboard")}
                        sx={{ alignSelf: { xs: "flex-start", md: "center" }, textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                    >
                        Voltar
                    </Button>
                </Box>

                <Box
                    sx={{
                        mt: 2,
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "minmax(0, 3fr) minmax(0, 1.2fr)" },
                        gap: 2,
                        alignItems: "start",
                    }}
                >
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        <SecaoCard icone={<BusinessIcon />} titulo="Prestador" descricao="Dados da sua empresa, preenchidos automaticamente">
                            <Box sx={linhaCamposSx("1fr 1fr")}>
                                <TextField size='small' label="CPF ou CNPJ" disabled required value={MascaraCnpj(user?.empresa?.cnpj)} variant="outlined" fullWidth sx={campoSx} />
                                <TextField size='small' label="Razão Social" disabled required value={user?.empresa?.razaoSocial || ""} variant="outlined" fullWidth sx={campoSx} />
                            </Box>
                        </SecaoCard>

                        <SecaoCard
                            icone={<PersonOutlineIcon />}
                            titulo="Tomador"
                            descricao="Quem recebeu o serviço (paciente, clínica ou hospital)"
                            acao={
                                <FormControlLabel
                                    control={<Checkbox size="small" checked={hasTomador} onChange={(e) => setHasTomador(e.target.checked)} sx={{ "&.Mui-checked": { color: "#0b243d" } }} />}
                                    label="Nota possui tomador?"
                                    sx={{ mr: 0, "& .MuiFormControlLabel-label": { fontSize: 13, color: "#374151" } }}
                                />
                            }
                        >
                            {hasTomador ? (
                                <>
                                    <Box sx={linhaCamposSx("1fr 1fr")}>
                                        <TextField size='small' label="CPF ou CNPJ" required value={cpfCnpjTomador} onChange={(e) => handleCpfCnpjTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} helperText="Com CNPJ completo, os dados são preenchidos automaticamente" />
                                        <TextField size='small' label="Razão Social ou Nome" required value={razaoSocialTomador} onChange={(e) => setRazaoSocialTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                    </Box>
                                    <Box sx={linhaCamposSx("1fr 1fr")}>
                                        <TextField size='small' label="E-mail" value={emailTomador} onChange={(e) => setEmailTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                        <TextField size='small' label="Inscrição Municipal" value={inscricaoMunicipalTomador} onChange={(e) => setInscricaoMunicipalTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                    </Box>
                                    <Box sx={linhaCamposSx("1fr 2fr 0.6fr")}>
                                        <TextField size='small' label="CEP" value={cepTomador} onChange={(e) => handleCepTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} helperText={cepTomador && !codigoIbgeTomador ? "Município não identificado pelo CEP" : ""} />
                                        <TextField size='small' label="Endereço" value={enderecoTomador} onChange={(e) => setEnderecoTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                        <TextField size='small' label="Nº" value={numeroTomador} onChange={(e) => setNumeroTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                    </Box>
                                    <Box sx={linhaCamposSx("1fr 1fr 1fr")}>
                                        <FormControl fullWidth size='small' sx={campoSx}>
                                            <InputLabel id="estado-tomador-select-label">Estado</InputLabel>
                                            <Select
                                                labelId="estado-tomador-select-label"
                                                id="estado-tomador-select"
                                                value={estadoTomador}
                                                label="Estado"
                                                onChange={handleChange}
                                            >
                                                {estados.map((uf) => (
                                                    <MenuItem key={uf} value={uf}>{uf}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <TextField size='small' label="Cidade" value={cidadeTomador} onChange={(e) => setCidadeTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                        <TextField size='small' label="Bairro" value={bairroTomador} onChange={(e) => setBairroTomador(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                    </Box>
                                    <FormControlLabel
                                        control={<Checkbox size="small" checked={enviarEmailTomador} disabled={!emailTomador} onChange={(e) => setEnviarEmailTomador(e.target.checked)} sx={{ "&.Mui-checked": { color: "#0b243d" } }} />}
                                        label="Enviar a nota por e-mail ao tomador após a autorização"
                                        sx={{ mr: 0, "& .MuiFormControlLabel-label": { fontSize: 13, color: "#374151" } }}
                                    />
                                </>
                            ) : (
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, backgroundColor: "#fef3c7", color: "#b45309", borderRadius: "8px", px: 1.5, py: 1 }}>
                                    <InfoOutlinedIcon sx={{ fontSize: 18 }} />
                                    <Typography sx={{ fontSize: 13, fontWeight: 500 }}>Nota fiscal de serviço sem tomador.</Typography>
                                </Box>
                            )}
                        </SecaoCard>

                        <SecaoCard icone={<MedicalServicesOutlinedIcon />} titulo="Serviço" descricao="Serviço prestado, tributação e valores">
                            <Autocomplete
                                size="small"
                                fullWidth
                                disablePortal
                                options={servicos}
                                getOptionLabel={(option) =>
                                    `${option.codigo} - ${option.cnae ? option.cnae : 'N/A'} - ${option.discriminacao}`
                                }
                                value={servicoSelecionado}
                                onChange={(event, newValue) => {
                                    setServicoSelecionado(newValue);
                                    setDescricaoServico(newValue?.discriminacao || '');
                                }}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            paddingY: 0.5,
                                        }}
                                    >
                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                            codigo: {option.codigo} cnae: {option.cnae ? option.cnae : 'N/A'}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            {option.discriminacao}
                                        </Typography>
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField {...params} label="Selecione o serviço" placeholder='Selecione o serviço que foi prestado' variant="outlined" sx={campoSx} />
                                )}
                            />
                            <TextField size="small" label="Descrição do Serviço" multiline minRows={2} value={descricaoServico} onChange={e => setDescricaoServico(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                            <Box sx={linhaCamposSx("1fr 1fr")}>
                                <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} size='small' label="Valor do Serviço" value={valorServico} onChange={e => setValorServico(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                <TextField size="small" label="Alíquota Simples Nacional / Mês (%)" value={aliquota} onChange={e => setAliquota(e.target.value)} variant="outlined" fullWidth sx={campoSx} helperText="Enviada como alíquota de ISS da nota" />
                            </Box>

                            <Button
                                size="small"
                                startIcon={mostrarAvancadas ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                onClick={() => setMostrarAvancadas(!mostrarAvancadas)}
                                sx={{ alignSelf: "flex-start", textTransform: "none", fontSize: 13, fontWeight: 600, color: "#1976d2", px: 0.5, "&:hover": { backgroundColor: "transparent", textDecoration: "underline" } }}
                            >
                                {mostrarAvancadas ? "Ocultar configurações avançadas" : "Mostrar configurações avançadas"}
                            </Button>

                            <Collapse in={mostrarAvancadas} unmountOnExit>
                                <Box sx={{ backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
                                    <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#111827" }}>Informações da Nota</Typography>
                                    <Box sx={linhaCamposSx("1fr 1fr 1fr 1fr")}>
                                        <TextField size="small" type="date" label="Data de Competência" value={dataCompetencia} onChange={e => setDataCompetencia(e.target.value)} InputLabelProps={{ shrink: true }} variant="outlined" fullWidth sx={campoSx} />
                                        <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} size='small' label="Deduções (R$)" value={deducoes} onChange={e => setDeducoes(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                        <TextField size="small" label="Base de Cálculo (R$)" disabled value={moeda(baseCalculo)} variant="outlined" fullWidth sx={campoSx} />
                                        <TextField size="small" label="Valor Líquido (R$)" disabled value={moeda(valorLiquido)} variant="outlined" fullWidth sx={campoSx} />
                                    </Box>
                                    <FormControl fullWidth size='small' sx={campoSx}>
                                        <InputLabel id="tipo-tributacao-select-label">Natureza da tributação</InputLabel>
                                        <Select
                                            labelId="tipo-tributacao-select-label"
                                            id="tipo-tributacao-select"
                                            value={tipoTributacao}
                                            label="Natureza da tributação"
                                            onChange={(e) => setTipoTributacao(e.target.value)}
                                        >
                                            {tiposTributacao.map((tipo) => (
                                                <MenuItem key={tipo.valor} value={tipo.valor}>{tipo.label}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <Divider />
                                    <TextField size="small" label="Informações Complementares" multiline minRows={3} value={informacoesComplementares} onChange={e => setInformacoesComplementares(e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                </Box>
                                <Box sx={{ mt: 1 }}>
                                    <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#111827" }}>Retenções</Typography>
                                    <Divider sx={{ mt: 1, mb: 1.5 }} />
                                    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(auto-fill, minmax(180px, 1fr))" }, gap: 1.5 }}>
                                        {retencoesFederais.map((r) => (
                                            <Box key={r.chave} sx={{ backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#374151" }}>Reter {r.label}</Typography>
                                                    <Switch size="small" checked={retencoes[r.chave].ativo} onChange={e => atualizarRetencao(r.chave, "ativo", e.target.checked)} />
                                                </Box>
                                                <NumericFormat customInput={TextField} allowLeadingZeros prefix="R$ " valueIsNumericString decimalSeparator="," decimalScale={2} disabled={!retencoes[r.chave].ativo} size='small' placeholder="Valor retido" value={retencoes[r.chave].valor} onChange={e => atualizarRetencao(r.chave, "valor", e.target.value)} variant="outlined" fullWidth sx={campoSx} />
                                            </Box>
                                        ))}
                                        <Box sx={{ backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "10px", p: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#374151" }}>ISS retido</Typography>
                                                <Switch size="small" checked={reterISS} onChange={e => setReterISS(e.target.checked)} />
                                            </Box>
                                            <TextField size="small" disabled value={moeda(valorIss)} helperText={`${aliquotaIss}% da base de cálculo`} variant="outlined" fullWidth sx={campoSx} />
                                        </Box>
                                    </Box>
                                </Box>
                            </Collapse>

                        </SecaoCard>
                    </Box>

                    {/* Resumo da nota */}
                    <Box sx={{ position: { md: "sticky" }, top: { md: 80 }, display: "flex", flexDirection: "column", gap: 2 }}>
                        <Box sx={{ ...cardSx, backgroundColor: "#0b243d", border: "none", color: "#fff" }}>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                                <Chip
                                    label="Resumo da nota"
                                    size="small"
                                    sx={{ backgroundColor: "rgba(255, 200, 69, 0.15)", color: "#ffc845", fontWeight: 700, fontSize: 10, height: 20, letterSpacing: 0.6, textTransform: "uppercase" }}
                                />
                                <ReceiptLongOutlinedIcon sx={{ fontSize: 20, color: "#94a3b8" }} />
                            </Box>

                            <Box sx={{ mt: 2, backgroundColor: "rgba(255, 255, 255, 0.06)", borderRadius: "10px", p: 1.5 }}>
                                <Typography sx={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6 }}>Tomador</Typography>
                                <Typography noWrap sx={{ mt: 0.25, fontSize: 14, fontWeight: 700 }}>
                                    {hasTomador ? (razaoSocialTomador || "Não informado") : "Sem tomador"}
                                </Typography>
                                {hasTomador && cpfCnpjTomador && (
                                    <Typography sx={{ fontSize: 11, color: "#94a3b8" }}>{cpfCnpjTomador}</Typography>
                                )}
                                <Typography sx={{ mt: 1.5, fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.6 }}>Serviço</Typography>
                                <Typography sx={{ mt: 0.25, fontSize: 13, fontWeight: 600, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                                    {servicoSelecionado ? servicoSelecionado.discriminacao : "Nenhum serviço selecionado"}
                                </Typography>
                            </Box>

                            <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 1 }}>
                                <LinhaResumo label="Valor do serviço" valor={moeda(valorBruto)} />
                                <LinhaResumo label="Deduções" valor={`- ${moeda(totalDeducoes)}`} />
                                <LinhaResumo label="Base de cálculo" valor={moeda(baseCalculo)} />
                                <LinhaResumo label={`ISS (${aliquotaIss}%)${reterISS ? " retido" : ""}`} valor={moeda(valorIss)} />
                                <LinhaResumo label="Total retido" valor={`- ${moeda(totalRetido)}`} />
                                <Box sx={{ borderTop: "1px solid rgba(255, 255, 255, 0.1)", my: 0.5 }} />
                                <LinhaResumo label="Valor líquido" valor={moeda(valorLiquido)} destaque />
                            </Box>

                            <Button
                                fullWidth
                                variant="contained"
                                startIcon={<ReceiptLongOutlinedIcon />}
                                onClick={handleEmitirNota}
                                disabled={emitindo}
                                sx={{
                                    mt: 2.5,
                                    py: 1.25,
                                    textTransform: "none",
                                    fontSize: 14,
                                    fontWeight: 700,
                                    color: "#111827",
                                    backgroundColor: "#ffc845",
                                    borderRadius: "8px",
                                    boxShadow: "none",
                                    "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" },
                                }}
                            >
                                {emitindo ? "Enviando..." : "Emitir nota fiscal"}
                            </Button>
                        </Box>

                        <Box sx={{ ...cardSx, display: "flex", gap: 1.5, p: 2 }}>
                            <InfoOutlinedIcon sx={{ fontSize: 18, color: "#6b7280", mt: 0.25 }} />
                            <Typography sx={{ fontSize: 12, color: "#4b5563" }}>
                                Após a emissão, a nota aparece em <Link underline="hover" sx={{ cursor: "pointer", fontWeight: 600, color: "#111827" }} onClick={() => navigate("../Dashboard/NotasFiscaisEmitidas")}>Notas fiscais emitidas</Link>.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Loading open={open} setOpen={setOpen} />
            <AlertError openSnackbarError={openSnackbarError} setOpenSnackbarError={setOpenSnackbarError} mensagem={mensagem} />
            <AlertSuccess openSnackbarSuccess={openSnackbarSuccess} setOpenSnackbarSuccess={setOpenSnackbarSuccess} mensagem={mensagem} />
        </>
    )
}


export default EmitirNotaServico;